import { domToPng } from 'modern-screenshot';

function wrapText( context, text, x, y, maxWidth, lineHeight ) {

    const words = text.split( ' ' );

    let line = '';

    let currentY = y;

    for ( let n = 0; n < words.length; n++ ) {

        const testLine = `${ line + words[ n ] } `;
        const metrics = context.measureText( testLine );
        const testWidth = metrics.width;

        if ( testWidth > maxWidth && n > 0 ) {

            context.fillText( line, x, currentY );
            line = `${ words[ n ] } `;
            currentY += lineHeight;

        }
        else {

            line = testLine;

        }

    }
    context.fillText( line, x, currentY );

    return currentY;

}

const exportElementAsImage = async ( el, trigger, imageFileName = 'chart.png', header, subHeader, watermark ) => {

    // TURN OFF ANIMATION when downloading
    const animations = document.getAnimations();

    animations.forEach( ( animation ) => {

        animation.finish();

    } );

    trigger.style.display = 'none';

    const removeElementsOnDownload = document.querySelectorAll( '.remove-when-downloading' );

    removeElementsOnDownload.forEach( ( el ) => {

        el.style.display = 'none';

    } );

    const chartQuarterDots = Array.from( document.getElementsByClassName( 'chart-quarter-dot-per-line' ) );

    if ( chartQuarterDots ) {

        chartQuarterDots.forEach( ( dot ) => {

            dot.style.visibility = 'hidden';

        } );

    }

    const legendCheckboxes = document.querySelectorAll( '.legend-chart .legend-text input[type=checkbox]' );

    domToPng( el );
    domToPng( el );
    domToPng( el );

    if ( legendCheckboxes ) {

        legendCheckboxes.forEach( ( checkbox ) => {

            if ( checkbox.checked === true ) {

                checkbox.style.appearance = 'none';
                checkbox.setAttribute( 'checked', true );

            }

        } );

    }
    try {

        const dataUrl = await domToPng( el, { scale: 2, quality: 1 } );

        if ( legendCheckboxes ) {

            legendCheckboxes.forEach( ( checkbox ) => {

                if ( checkbox.checked === true ) {

                    checkbox.style.appearance = 'auto';
                    checkbox.removeAttribute( 'checked' );

                }

            } );

        }

        if ( header || watermark ) {

            const img = new Image();

            img.src = dataUrl;

            img.onload = () => {

                const canvas = document.createElement( 'canvas' );
                const ctx = canvas.getContext( '2d' );

                canvas.width = img.width;
                canvas.height = img.height;
                ctx.fillStyle = 'white';
                ctx.fillRect( 0, 0, canvas.width, canvas.height );

                var finalY = null;
                var spacingAboveChart = null;

                if ( header ) {

                    const headerFontSize = 24 * 2;
                    const headerLineHeight = 28 * 2;
                    const subHeaderFontSize = 16 * 2;
                    const subHeaderLineHeight = 18.5 * 2;

                    spacingAboveChart = 68;
                    const spacingBetweenHeaders = 40;

                    ctx.font = '600 48px TiemposHeadline';
                    ctx.fillStyle = '#011e4d';
                    finalY = wrapText( ctx, header, 0, headerFontSize, img.width, headerLineHeight );

                    var finalYSub = null;

                    if ( subHeader ) {

                        ctx.font = '32px Arial';
                        ctx.fillStyle = '#556074';
                        finalYSub = wrapText( ctx, subHeader, 0, finalY + subHeaderFontSize + spacingBetweenHeaders, img.width, subHeaderLineHeight );

                    }

                    canvas.width = img.width;
                    canvas.height = img.height + ( subHeader ? finalYSub + spacingBetweenHeaders + spacingAboveChart : finalY + spacingAboveChart );
                    ctx.fillStyle = 'white';
                    ctx.fillRect( 0, 0, canvas.width, canvas.height );

                    ctx.font = '600 48px TiemposHeadline';
                    ctx.fillStyle = '#011e4d';
                    finalY = wrapText( ctx, header, 0, headerFontSize, img.width, headerLineHeight );
                    if ( subHeader ) {

                        ctx.font = '32px Arial';
                        ctx.fillStyle = '#556074';
                        finalYSub = wrapText( ctx, subHeader, 0, finalY + subHeaderFontSize + spacingBetweenHeaders, img.width, subHeaderLineHeight );

                    }

                }
                else {

                    const watermarkFontSize = 16 * 2;
                    const watermarkLineHeight = 24 * 2;

                    spacingAboveChart = 24;

                    ctx.font = '600 32px TiemposHeadline';
                    ctx.fillStyle = '#929FB2';
                    ctx.textAlign = 'center';
                    finalY = wrapText( ctx, watermark, canvas.width / 2, watermarkFontSize, img.width, watermarkLineHeight );

                    canvas.width = img.width;
                    canvas.height = img.height + finalY + spacingAboveChart;
                    ctx.fillStyle = 'white';
                    ctx.fillRect( 0, 0, canvas.width, canvas.height );

                    ctx.font = '600 32px TiemposHeadline';
                    ctx.fillStyle = '#929FB2';
                    ctx.textAlign = 'center';
                    finalY = wrapText( ctx, watermark, canvas.width / 2, watermarkFontSize, img.width, watermarkLineHeight );

                }

                ctx.drawImage( img, 0, subHeader ? finalYSub + spacingAboveChart : finalY + spacingAboveChart, img.width, img.height );

                const finalDataUrl = canvas.toDataURL( 'image/png' );

                const link = document.createElement( 'a' );

                link.download = imageFileName;
                link.href = finalDataUrl;
                link.click();
                trigger.style.display = 'flex';

            };

        }
        else {

            const link = document.createElement( 'a' );

            link.download = imageFileName;
            link.href = dataUrl;
            link.click();
            trigger.style.display = 'flex';

        }

        if ( chartQuarterDots ) {

            chartQuarterDots.forEach( ( dot ) => {

                dot.style.visibility = 'visible';

            } );

        }

        removeElementsOnDownload.forEach( ( el ) => {

            el.style.display = 'flex';

        } );

    }
    catch ( error ) {

        console.error( 'Error generating or downloading image:', error );

    }

};

export default exportElementAsImage;
